import { render, staticRenderFns } from "./yongh_config.vue?vue&type=template&id=778b24dc&scoped=true&"
import script from "./yongh_config.vue?vue&type=script&lang=js&"
export * from "./yongh_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b24dc",
  null
  
)

export default component.exports